import Modal from './accessibility';
import Dom from '../Utility/Dom';
import {debouncer, documentReady} from '../Utility/utils';


documentReady(event => {

  // Modal Open
  Dom.modalTrigger.forEach(item => {
    item.addEventListener('click', modalOpen);
    item.addEventListener('keypress', modalOpen);
  });

  // In the event a modal link is added without the modal-target attr, try to check if it's got a modal id as an href attr.
  document.addEventListener('click', function(e){
    if (e.target.matches('a') || !!e.target.closest('a')) {
      const clickedLink = e.target.matches('a') ? e.target : e.target.closest('a');
      const href = clickedLink.getAttribute('href');
      if (/^#/.test(href)) {
        const hash = href.substring(href.indexOf("#"));
        const hashTarget = document.getElementById(hash.substring(1));
        if (hash !== "#" && hashTarget && hashTarget.classList.contains('modal')) {
          clickedLink.classList.add('modalTriggerClicked');
          modalOpen(e, hashTarget);

          // if it's the admin area, ensure the modal is sized correctly.
          set_admin_modal_css();
        }
      }
    }
  });

  function modalOpen(e, modalEl = false){
    e.preventDefault();
    const el = e.target.matches('a') ? e.target : e.target.closest('a');
    if(e.type === 'click' || e.key === 'Enter' ){
      const target = modalEl ? modalEl : document.getElementById(el.getAttribute('modal-target'));
      if(!target){
        return;
      }

      target.classList.add('opening');
      target.classList.add('active');
      target.setAttribute('aria-hidden', 'false');
      target.setAttribute('tabindex','1');

      Dom.body.classList.add('scroll-lock');
      Dom.body.classList.add('modal-active');

      setTimeout(function(){
        target.classList.remove('opening');
      }, 1);

      // Handles trapping focus in modal
      Modal.open(target);

      // add active class to body
      const body = document.querySelector('body');
      if(!body.classList.contains('wp-admin')){
        body.classList.add('modal-active');
      }

      if (target.querySelectorAll('iframe').length) {
        var _modalFrame = target.querySelectorAll('iframe');
        _modalFrame[0].src += '&autoplay=1';
      }
      else if(modalEl.classList.contains('video_modal')){
        const video = modalEl.querySelector('video');
        video.play();
      }
    }
  }


  // Modal Close
  document.addEventListener('click', function(e) {
    if (e.target.matches('a.modal__close') || !!e.target.closest('a.modal__close') || e.target.matches('.modal')) {
      modalClose(e);
    }
  });
  document.addEventListener('keypress', function(e) {
    if (e.target.matches('a.modal__close') || !!e.target.closest('a.modal__close') || e.target.matches('.modal')) {
      modalClose(e);
    }
  });

  function modalClose(e){
    if(e.key === 'Enter' || e.type === 'click'){
      e.preventDefault();
      let target = e.target.matches('.modal') ? e.target : e.target.closest('.modal');
      target.classList.add('closing');

      setTimeout(function(){
        target.setAttribute('aria-hidden', 'true');
        target.setAttribute('tabindex','-1');
        Dom.body.classList.remove('scroll-lock');
        Dom.body.classList.remove('modal-active');
        target.classList.remove('active');
        target.classList.remove('closing');
      }, 300);

      // Handles un-trapping focus in modal
      Modal.close(target);

      // remove active class to body
      const body = document.querySelector('body');
      if(body.classList.contains('modal-active')){
        body.classList.add('modal-active');
      }

      // Look for modal trigger button originally clicked to restore focus
      const modalTrigger = document.querySelector('.modalTriggerClicked');
      if(!!modalTrigger){
        modalTrigger.focus();
        modalTrigger.blur();
        modalTrigger.classList.remove('modalTriggerClicked');
      }

      if (target.querySelectorAll('iframe').length) {
        // reset the iframe src to stop iframe playing
        var _modalFrame = target.querySelectorAll('iframe');
        var src = _modalFrame[0].getAttribute('src');

        var newsrc = src.replace('&autoplay=1', '');
        _modalFrame[0].setAttribute('src', newsrc);
      }
      else if(target.classList.contains('video_modal')){
        const video = target.querySelector('video');
        video.pause();
        
        setTimeout(()=>{
          video.currentTime = 0;
        }, 300);
      }
    }
  };


  // ADMIN SECTION - HELP ADMIN EDITOR LAYOUT
  const body = document.getElementsByTagName("body")[0];

  function set_admin_modal_css(){
    if(body.classList.contains('block-editor-page')){
      let counterCheck = 0;

      // Because block editor markup isn't immediately loaded when the page is loaded, we may have to check multiple times.
      let checkForContentArea = setInterval(function(){
        counterCheck++;

        const contentArea = document.querySelector('.interface-interface-skeleton__content');

        // contenArea is found
        if(counterCheck > 20 || contentArea){
          // clear the interval
          clearInterval(checkForContentArea);

          // get css values needed from content area
          const contentWidth = contentArea.clientWidth;
          const contentLeft = contentArea.getBoundingClientRect().left;

          // set width on all modals
          const modals = document.querySelectorAll('.modal');
          modals.forEach(item => {
            item.style.width = contentWidth + 'px';
            item.style.left = contentLeft + 'px';
          });
        }
      }, 50);
    }
  }
  set_admin_modal_css();

  // Resize modals on window resize
  window.addEventListener('resize', debouncer(function(){
    set_admin_modal_css();
  }, 15));

  // Resize modals when editor ui changes (fullscreen mode change or right sidebar show/hide)
  document.addEventListener('click', function(e){
    if(e.target.matches('button') || !!e.target.closest('button')){
      const button = e.target.matches('button') ? e.target : e.target.closest('button');
      if(!!button.closest('.edit-post-header__settings') || !!button.closest('.components-dropdown-menu__menu')){
        setTimeout(function(){
          set_admin_modal_css();
        }, 100);
      }
    }
  });

  // Add modal ID to the instructions in the block editor panel, showing how to link to the modal in another button if needed.
  if(body.classList.contains('block-editor-page')){
    document.addEventListener('click', function(e){
      const selected_block = document.querySelector('.wp-block.is-selected');
      if(!!selected_block){
        const modal = selected_block.querySelector('.modal');
        if(modal && !e.target.closest('.acf-block-panel')){
          const modal_id = modal.getAttribute('id');

          let checkForInstructions = setInterval(function(){
            const modalInstructionID = document.querySelector('.modal_block_id');

            // ID span found
            if(modalInstructionID){
              // clear the interval
              clearInterval(checkForInstructions);

              // Add the ID.
              modalInstructionID.innerHTML = modal_id;
            }
          }, 50);
        }
      }
    });
  }
});
